<template>
  <div id="sales">
    <div class="container" v-show="!showDatatable">
      <div>
        <button @click="back">{{ $t('back') }}</button>
      </div>
      <hr>
      <json-viewer :value="jsonError" />
      <json-viewer :value="jsonRequest" :expand-depth=5 copyable boxed sort />
    </div>
    <Datatable class="datatable" entity="failed_sale" ref="datatable" :parameters="{ company: companyId }"
      :onRowClick="onRowClick" :rowActions="[]" v-show="showDatatable" />
  </div>
</template>

<script>
  import Datatable from "@/components/Datatable.vue";
  import JsonViewer from 'vue-json-viewer'

  export default {

    name: 'failedSales',

    components: { Datatable, JsonViewer },

    data() {
      return {
        showDatatable: true,
        jsonRequest: {},
        jsonError: {}
      }
    },

    computed: {
      companyId() {
        return this.$store.state.contextCompany ? this.$store.state.contextCompany.id : undefined
      }
    },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "sales.title";
      this.$store.state.pageIcon = "/icon/sales.svg";
    },

    methods: {
      onRowClick(row) {
        this.showDatatable = false;
        this.jsonError = JSON.parse(row.errors);
        this.jsonRequest = JSON.parse(row.request);
      },
      back() {
        this.jsonRequest = {};
        this.showDatatable = true;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .datatable {
    height: 100%;
  }
</style>